import React from "react";

import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import { Switch, Route } from "react-router";
import UserEdit from "../../features/user-edit";
import UserCrewsList from "../../features/user-crews-list";
import { StyledTabs } from "../../components/Base";

const ProfileNavigation = ({ match, history }) => {
  const { pageId } = match.params;

  const navigateTo = (_, value) => {
    const subpage = v(value);
    history.push(`/profile/${subpage}`);
  };

  const pages = ["edit", "crews"];

  const rv = (subpage) => pages.indexOf(subpage);
  const v = (i) => pages[i];

  return (
    <StyledTabs variant="fullWidth" value={rv(pageId)} indicatorColor="primary" onChange={navigateTo}>
      <Tab label="Profile" />
      <Tab label="Company Affilation" />
    </StyledTabs>
  );
};

const Profile = ({ match, history }) => {
  return (
    <>
      <Route path={`${match.path}/:pageId`} component={ProfileNavigation} />
      <Switch>
        <Route exact path={`${match.path}/edit`}>
          <Typography variant="h4">My Profile Data</Typography>
          <UserEdit match={match} history={history} />
        </Route>
        <Route exact path={`${match.path}/crews`}>
          <Typography variant="h4">Edit companies</Typography>
          <UserCrewsList />
        </Route>
      </Switch>
    </>
  );
};

export default Profile;
